<template>
<div>
    <h5 class="cabecera">Productos</h5>
    <div class="linea">
    </div>
    <md-table v-model="issue.productos">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Producto" class="td-name">
          {{ item.codigo}} <br> {{item.descripcion_larga}}
          <br />
          <!-- <small>{{ item.descripcion }}</small> -->
        </md-table-cell>
        <md-table-cell md-label="Albarán" class="td-name">{{item.albaran.numero}}</md-table-cell>
        <md-table-cell md-label="Incidencia">{{ item.incidencia.subtipo }}</md-table-cell>
        <md-table-cell md-label="Unidades Afectadas">{{ item.unidadesAfectadas }}</md-table-cell>
        <md-table-cell md-label="Nro. Lote">
            {{item.numero_lote}}
        </md-table-cell>
        <md-table-cell md-label="Imagenes">
        <div class="photos">
          <img v-if="item.idFoto"
            class="issue-photo"
            :src="getIssueImageUrl(item.idFoto)"
            :key="item.idFoto"
            @click="showImage(item.idFoto)"
          />
        </div>
        </md-table-cell> 
        
        
        <div v-if="show_photo" class="photo-viewer">
          <!-- <div class="photo-wrapper"> -->
          <div class="photo-container">
            <md-button class="md-button md-round md-warning photo-button" @click="closeImage()">Cerrar</md-button>
            <img :src="selected_image" />
        </div>
        <!-- </div> -->
      </div>
      </md-table-row>
    </md-table>
</div>
</template>
<script>
import { apiServer, staticServer, florette_web } from "@/globalVars.js";
import { SectionPanel } from "@/components";

export default {
  name: "issue-productos-afectados",
  components: { SectionPanel },
  props: {
    issue: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      new_comment: "",
      user: "",
      show_photo: false,
      selected_image: ""
    };
  },
  methods: {
    closeissueView() {
      this.$emit("close");
    },
    getIssueImageUrl(image_file) {
      return staticServer + "reclamaciones/" + image_file;
    },
    showImage(photo) {
      this.show_photo = true;
      this.selected_image = staticServer + "reclamaciones/" + photo;
    },
    closeImage() {
      this.show_photo = false;
      this.selected_image = "";
    },
    getDateString(value) {
      if (value != null) {
        let d = new Date(value);
        return d.toLocaleString("es-ES", { timeZone: "Europe/Madrid" });
      }
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
.linea{
  border-bottom: #e0f3e7 solid 1px;
  width:100%;padding-bottom: 0px;
  margin-top: -15px;
}
.cabecera{
  padding-bottom: 0%;
  padding-left: 10px;
  padding-top: 10px;
  font-weight: bold;
  font-size: 15px;
  color:#2a6917;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 30px;
  width: 190px;
  background-color: #e0f3e7;
}
.modal-container {
  max-width: 900px !important;
}
.modal-body {
  height: 500px !important;
  overflow-y: auto !important;
}
.issue-photo {
  width: 55px;
  height: 55px;
  padding: 0% !important;
  cursor: pointer;
}
.photos {
  padding-top: 20px !important;
  display: flex;
  justify-content: space-between;
}
.photo-viewer {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  -webkit-transition: opacity 0.15s ease;
  transition: opacity 0.15s ease;
  align-items: center;
  justify-content: center;
}
.photo-wrapper {
  display: inline;
  vertical-align: middle;
}
.photo-container {
  display: block;
  max-width: 900px;
  margin: 0px auto;
  position: relative;
  background-color: #fff;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  -webkit-box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2),
    0 40px 77px 0 rgba(0, 0, 0, 0.22);
  box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2),
    0 40px 77px 0 rgba(0, 0, 0, 0.22);
  border-radius: 6px;
  border: none;
  height: fit-content;
  max-height: 100%;
  overflow: auto;
}
.photo-container > img {
  padding: 10px;
}
.photo-button {
  top: 20px;
  float: right;
  position: absolute;
  right: 20px;
}
</style>


